/**
 * Zentraler Helper für Thumbnail-Auswahl.
 *
 * Regeln:
 *  - Wenn `poster_url` gesetzt (R2 CDN) → nutzen.
 *  - Sonst: Bilder → `stored_url` bzw. `/api/media/{id}`.
 *  - Videos ohne Poster → `null` (Aufrufer rendert Placeholder mit Video-Icon).
 *
 * Wird in `/admin/medien`, `/admin/projekte/:id` und `/projekt/:slug` verwendet,
 * damit ein Fix an einer Stelle für alle drei Ansichten wirkt.
 */
export type MediaLite = {
    id: string;
    mime: string;
    media_type?: string | null;
    stored_url?: string | null;
    poster_url?: string | null;
    poster_filename?: string | null;
};

const PHOTO_TYPES = new Set([
    "photo", "photo_360", "fisheye", "tiny_planet", "before", "after",
]);

export function mediaThumb(m: MediaLite, backendUrl: string): string | null {
    // Poster hat immer Vorrang (R2-CDN oder lokal)
    if (m.poster_url) return m.poster_url;
    if (m.poster_filename) return `${backendUrl}/api/media/${m.id}/poster`;

    // Bilder direkt anzeigen
    if (m.mime?.startsWith("image/") || (m.media_type && PHOTO_TYPES.has(m.media_type))) {
        return m.stored_url || `${backendUrl}/api/media/${m.id}`;
    }

    // Videos ohne Poster → kein Thumb (Aufrufer zeigt Placeholder)
    return null;
}
